/* eslint-disable */
export default {
  today: 'Aujourd’hui',
  yesterday: 'Hier',
  empty: 'Aucun enregistrement de l’appel',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
